export default __webpack_public_path__ + "static/media/gl_1.05e93b20.mp3";